export default __webpack_public_path__ + "img/img_tyler-c096031167adbef28597734aee0a274b.jpg";